import { Resources } from "../models/resources";

export const getResourceByNameGroup = (
  group: string,
  subGroup: string,
  name: string,
  resources?: Resources[]
) => {
  if (resources && resources?.length > 0)
    return resources?.find(
      (resource) =>
        resource?.name?.toLowerCase() === name?.toLowerCase() &&
        resource?.subGroup?.toLowerCase() === subGroup?.toLowerCase() &&
        resource?.group?.toLowerCase() === group?.toLowerCase()
    );

  return null;
};
